import { useFormContext } from 'react-hook-form'
import { Small } from '@/components/sv/typographies'
import { Badge } from '@/components/ui/badge'
import { gql } from '@/lib/graphql/gql'
import { useIdCompany, useSuspenseQuery } from '@/lib/hooks'
import { cn } from '@/lib/utils'
import type { CreateDatabaseFormValues } from '@/routes/databases/create-database/form/schema'
import type {
  ResourceTypesQuery,
  ResourceTypesQueryVariables,
} from '@/routes/databases/create-database/form/sections/overview/estimation.types.gen'
import type { ReactElement } from 'react'

export const RESOURCE_TYPES = gql`
  query ResourceTypes($idCompany: String!) {
    company(id: $idCompany) {
      id
      sevallaBilling {
        id
        taxPercent
      }
      databaseResourceTypes {
        id
        name
        cpuLimit
        memoryLimit
        price {
          unitNetPrice
          estimatedMonthlyPrice
        }
      }
    }
  }
`

export const Estimation = (): ReactElement => {
  const form = useFormContext<CreateDatabaseFormValues>()
  const idResourceType = form.watch('idResourceType')

  const { idCompany } = useIdCompany()
  const { data } = useSuspenseQuery<
    ResourceTypesQuery,
    ResourceTypesQueryVariables
  >(RESOURCE_TYPES, {
    variables: { idCompany },
  })

  const resourceType = data?.company?.databaseResourceTypes?.find(
    (resourceType) => resourceType?.id === idResourceType
  )

  const taxPercent = data?.company?.sevallaBilling?.taxPercent ?? 0

  const dbPrice = resourceType?.price?.estimatedMonthlyPrice
    ? resourceType?.price?.estimatedMonthlyPrice * (taxPercent / 100 + 1)
    : 'N/A'

  const content = (
    <div className="flex flex-col gap-3">
      {resourceType ? (
        <div className="flex items-center justify-between">
          <Small className="flex items-center gap-1.5">
            <Badge className={cn('w-8 uppercase')}>{resourceType?.name}</Badge>{' '}
            database
          </Small>
          <Small>${dbPrice} / month</Small>
        </div>
      ) : null}
    </div>
  )

  return content
}
